export default __webpack_public_path__ + "static/media/home_screen_new.3b99b5a5.png";